// extracted by extract-css-chunks-webpack-plugin
module.exports = {"searchResults":"css-1zbsbH8y6J","searchResults_inner":"css-1Ct7D-PYCV","searchResults_inner_headline":"css-1EPQctLr0Q"};